import {
  CheckoutLeft,
  CheckoutRight,
  CheckoutWrapper,
  Label,
  Name,
  NameQty,
  ProductImage,
  ProductImageWrapper,
  ProductInfo,
  ProductInfo1,
  ProductPrice,
  QtyNum,
  Quantity,
  SubTax,
  SummaryWrapper,
  Title,
  Value,
  Value1,
} from "./CheckoutComponent.styled";
import { useNavigate } from "react-router-dom";
import { productDetails, transformPrice } from "./data";
import { useStore } from "@nanostores/react";
import { checkoutProduct, selectedProduct } from "../../store/nanostore";
import React from "react";

interface CheckoutComponentReviewProps {
  products: any[];
  totalPrice: number;
  targetRef: any;
}
const CheckoutPageComponentReview: React.FC<CheckoutComponentReviewProps> = ({
  products,
  totalPrice,
  targetRef,
}) => {
  const navigate = useNavigate();

  return (
    <CheckoutWrapper ref={targetRef}>
      <CheckoutLeft>
        <img
          onClick={() => navigate("/")}
          src="/assets/icons/fipay.svg"
          alt="fipay"
          className="fipay_img"
        />
        <SummaryWrapper>
          <Title />
          {products?.map(({ product, id, quantity }: any, index: number) => (
            <ProductInfo key={id}>
              <ProductImageWrapper>
                {/* <ProductImage src={productDetails.image} alt={product.name} /> */}
                <NameQty>
                  <Name>{product.name}</Name>
                  <Quantity>Quantity: {product.quantity}</Quantity>
                </NameQty>
              </ProductImageWrapper>
              <ProductPrice>
                {transformPrice(product.price * (quantity || 1))}
              </ProductPrice>
            </ProductInfo>
          ))}
          <SubTax>
            <ProductInfo $noBorder>
              <Label>Sub total</Label>
              <Value>{transformPrice(totalPrice)}</Value>
            </ProductInfo>
            <ProductInfo $noBorder>
              <Label>Tax</Label>
              <Value>{transformPrice(productDetails.tax)}</Value>
            </ProductInfo>
          </SubTax>
          <ProductInfo1>
            <Label>Total</Label>
            <Value1>{transformPrice(totalPrice)}</Value1>
          </ProductInfo1>
        </SummaryWrapper>
      </CheckoutLeft>
      <CheckoutRight></CheckoutRight>
    </CheckoutWrapper>
  );
};

export default CheckoutPageComponentReview;
